import { gql } from "graphql-request";

export const CREATE_COMPANY_ADDRESS = gql`
  mutation CreateCompanyAddress($input: CreateCompanyAddressInput!) {
    createCompanyAddress(input: $input) {
      id
      companyID
      label
      addressLine1
      addressLine2
      town
      county
      postcode
      country
      latitude
      longitude
      isPrimary
      createdAt
      updatedAt
      archivedAt
    }
  }
`;

export const UPDATE_COMPANY_ADDRESS = gql`
  mutation UpdateCompanyAddress($input: UpdateCompanyAddressInput!) {
    updateCompanyAddress(input: $input) {
      id
      companyID
      label
      addressLine1
      addressLine2
      town
      county
      postcode
      country
      latitude
      longitude
      isPrimary
      createdAt
      updatedAt
      archivedAt
    }
  }
`;

export const ARCHIVE_COMPANY_ADDRESS = gql`
  mutation ArchiveCompanyAddress($id: ID!) {
    archiveCompanyAddress(id: $id)
  }
`;